import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import { useStore } from 'src/stores';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { Icon, TableLoader, InputWithIcon, SelectMenu, ExpandedTooltip } from '@livable/saas-react-components';
import { Container, Chip, TextField, MenuItem, IconButton, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { observer } from 'mobx-react-lite';
import { v4 as uuid } from 'uuid';
import { AppfolioBatchesModal } from './Modal';
import moment from 'moment';
import MonthRangeDatePicker from 'src/components/general/MonthRangeDatePicker';
export const AppfolioBatches = observer(() => {
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    modalData = _useState2[0],
    setModalData = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    modalIsOpen = _useState6[0],
    setModalIsOpen = _useState6[1];
  const _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    pendingBatches = _useState8[0],
    setPendingBatches = _useState8[1];
  const _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    pendingBatchesStatic = _useState0[0],
    setPendingBatchesStatic = _useState0[1];
  const _useState1 = useState(0),
    _useState10 = _slicedToArray(_useState1, 2),
    pendingBatchDeliveryLag = _useState10[0],
    setPendingBatchDeliveryLag = _useState10[1];
  const _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    search = _useState12[0],
    setSearch = _useState12[1];
  const _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    statusFilter = _useState14[0],
    setStatusFilter = _useState14[1];
  const _useState15 = useState({
      startDateOnly: null,
      //moment(store.properties.serverBusinessDateOnly).subtract(1, 'months').startOf('month').toDate(),
      endDateOnly: null //moment(store.properties.serverBusinessDateOnly).subtract(1, 'months').endOf('month').toDate(),
    }),
    _useState16 = _slicedToArray(_useState15, 2),
    customDateRange = _useState16[0],
    setCustomDateRange = _useState16[1];
  const property = store.homeDashboardStore.getCurrentProperty || {};
  const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const indicators = /*#__PURE__*/React.createElement("span", {
    className: "indicators"
  }, /*#__PURE__*/React.createElement("span", {
    className: "inline-arrow"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  })), /*#__PURE__*/React.createElement("span", {
    className: "inline-filter"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "equalizer"
  })));
  const renderHeader = (text, rightAlign) => /*#__PURE__*/React.createElement("span", {
    className: rightAlign ? classes.rightAlign : ''
  }, text, indicators);
  const Cell = _ref => {
    let value = _ref.value,
      _ref$isStatus = _ref.isStatus,
      isStatus = _ref$isStatus === void 0 ? false : _ref$isStatus;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !isStatus && /*#__PURE__*/React.createElement("span", {
      className: classes.cellContent
    }, value), isStatus && /*#__PURE__*/React.createElement(Chip, {
      label: capitalizeFirstLetter(value),
      variant: value === 'rejected' ? 'critical' : value === 'pending' ? 'warning' : 'success'
    }));
  };
  let columns = [{
    field: 'batchNumber',
    align: 'left',
    flex: 1,
    maxWidth: 280,
    valueGetter: v => {
      var _v$row;
      return +(v === null || v === void 0 || (_v$row = v.row) === null || _v$row === void 0 ? void 0 : _v$row.number);
    },
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.number
    }),
    renderHeader: () => renderHeader(t('Batch number'))
  }, {
    field: 'batchType',
    align: 'left',
    flex: 1,
    maxWidth: 250,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.batchType
    }),
    renderHeader: () => renderHeader(t('Batch type'))
  }, {
    field: 'batchStatus',
    align: 'left',
    flex: 1,
    maxWidth: 250,
    valueGetter: v => {
      var _v$row2, _v$row3;
      return (v === null || v === void 0 || (_v$row2 = v.row) === null || _v$row2 === void 0 ? void 0 : _v$row2.status) === 'rejected' ? 2 : (v === null || v === void 0 || (_v$row3 = v.row) === null || _v$row3 === void 0 ? void 0 : _v$row3.status) === 'pending' ? 1 : 0;
    },
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.status,
      isStatus: true
    }),
    renderHeader: () => renderHeader(t('Batch status'))
  }, {
    field: 'postMonth',
    align: 'left',
    flex: 1,
    maxWidth: 250,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.postMonth
    }),
    renderHeader: () => renderHeader(t('Post month'))
  }, {
    field: 'lastUpdatedAt',
    align: 'left',
    flex: 1,
    maxWidth: 250,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.lastUpdatedAt
    }),
    renderHeader: () => renderHeader(t('Last updated at'))
  }];
  const handleCellClick = params => {
    setModalData(params.row);
    setModalIsOpen(true);
  };
  const handleSearch = value => {
    setSearch(value);
    setPendingBatches(pendingBatchesStatic.filter(element => "".concat(element.number).toLocaleLowerCase().includes(value.toLocaleLowerCase()) && (statusFilter === 'all' || statusFilter === '' ? true : element.status === statusFilter) && (!customDateRange.startDateOnly || !customDateRange.endDateOnly ? true : moment(element.postMonth).isBetween(moment(customDateRange.startDateOnly), moment(customDateRange.endDateOnly), 'days', '[]'))));
  };
  const handleStatusChange = async event => {
    if (event.target.value) {
      setStatusFilter(event.target.value);
      setPendingBatches(pendingBatchesStatic.filter(element => "".concat(element.number).toLocaleLowerCase().includes(search.toLocaleLowerCase()) && (event.target.value === 'all' ? true : element.status === event.target.value) && (!customDateRange.startDateOnly || !customDateRange.endDateOnly ? true : moment(element.postMonth).isBetween(moment(customDateRange.startDateOnly), moment(customDateRange.endDateOnly), 'days', '[]'))));
    }
  };
  const getPendingBatches = async () => {
    const resp = await store.credentials.getPendingBatchesAsync.run({
      propertyLivableId: store.homeDashboardStore.selectedPropertyId
    });
    return resp;
  };
  const getPendingBatchDeliveryLag = async () => {
    const resp = await store.credentials.getPropertiesByIdAsync.run({
      propertyLivableId: store.homeDashboardStore.selectedPropertyId
    });
    if (resp && resp !== null && resp !== void 0 && resp.response) {
      setPendingBatchDeliveryLag(resp.response.pendingBatchDeliveryLag);
    }
    return resp;
  };
  useEffect(() => {
    if (property !== null && property !== void 0 && property.id) {
      setIsLoading(true);
      getPendingBatches().then(resp => {
        var _resp$response, _resp$response2;
        setPendingBatches(resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.sort((a, b) => {
          return moment(b.lastUpdatedAt) - moment(a.lastUpdatedAt);
        }));
        setPendingBatchesStatic(resp === null || resp === void 0 || (_resp$response2 = resp.response) === null || _resp$response2 === void 0 ? void 0 : _resp$response2.sort((a, b) => {
          return moment(b.lastUpdatedAt) - moment(a.lastUpdatedAt);
        }));
        setIsLoading(false);
      });
      getPendingBatchDeliveryLag();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [property === null || property === void 0 ? void 0 : property.id]);
  const handleDateChange = (fromDate, toDate) => {
    const result = {
      startDateOnly: fromDate === null ? null : moment(fromDate).toDate(),
      endDateOnly: toDate === null ? null : moment(toDate).toDate()
    };
    setCustomDateRange(result);
    if (result.startDateOnly && result.endDateOnly) setPendingBatches(pendingBatchesStatic.filter(element => "".concat(element.number).toLocaleLowerCase().includes(search.toLocaleLowerCase()) && (statusFilter === 'all' || statusFilter === '' ? true : element.status === statusFilter) && moment(element.postMonth).isBetween(moment(fromDate), moment(toDate), 'days', '[]')));
  };
  return /*#__PURE__*/React.createElement(Container, {
    className: classes.pageContainer
  }, isLoading ? /*#__PURE__*/React.createElement(TableLoader, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.filter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.filterWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.filterItem
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    type: "text",
    variant: "outlined",
    value: search,
    label: t('Search for batch by number'),
    onChange: e => handleSearch(e.target.value)
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.filterItem
  }, /*#__PURE__*/React.createElement(MonthRangeDatePicker, {
    label: t('Month batch created'),
    fromDateExternal: customDateRange.startDateOnly,
    toDateExternal: customDateRange.endDateOnly,
    handleDateChange: (fromDate, toDate) => handleDateChange(fromDate, toDate),
    format: 'MM/yyyy'
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.filterItem
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "property-selector",
    label: t('Batch status'),
    labelId: "property-selector-label",
    onChange: handleStatusChange,
    value: statusFilter
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: 'all'
  }, "All"), /*#__PURE__*/React.createElement(MenuItem, {
    value: 'approved'
  }, "Approved"), /*#__PURE__*/React.createElement(MenuItem, {
    value: 'pending'
  }, "Pending"), /*#__PURE__*/React.createElement(MenuItem, {
    value: 'rejected'
  }, "Rejected"))), (store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.filterItem, " ").concat(store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin ? 'batchQueue' : '')
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Batch queue:", /*#__PURE__*/React.createElement("br", null), !pendingBatchDeliveryLag ? 'All up to date' : "Update queue ".concat(pendingBatchDeliveryLag)), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: 'Refresh Data',
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.inlineTooltip,
    onClick: () => getPendingBatchDeliveryLag()
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "reload"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: classes.table
  }, /*#__PURE__*/React.createElement(DataGrid, {
    getRowId: () => uuid(),
    rows: pendingBatches,
    columns: columns,
    initialState: {
      pagination: {
        paginationModel: {
          pageSize: 25
        }
      }
    },
    pageSizeOptions: [25],
    disableRowSelectionOnClick: true,
    hideFooterSelectedRowCount: true,
    columnHeaderHeight: 48,
    rowHeight: 56,
    onCellClick: handleCellClick
  }))), modalIsOpen && /*#__PURE__*/React.createElement(AppfolioBatchesModal, {
    isOpen: modalIsOpen,
    modalData: modalData,
    handleOpen: () => setModalIsOpen(true),
    handleClose: () => setModalIsOpen(false)
  }));
});